import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/_app/requests-for-quotes')({
    component: () => <Outlet />,
});
